/* Extend the theme's existing variant lifecycle; checkout stays in product-form.js. */
if (!customElements.get('gx-buy-sync')) {
  customElements.define('gx-buy-sync', class extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) !== this.dataset.section) return;
        const productInfo = this.closest('product-info');
        if (!productInfo || !data.html) return;
        productInfo.querySelectorAll('[data-gx-buy-update]').forEach(target => {
          const source = data.html.getElementById(target.id);
          if (!source) return;
          // Preserve an open calendar and the customer's selection on shipping variants.
          if (target.hasAttribute('data-gx-calendar') && target.firstElementChild && source.firstElementChild) return;
          target.innerHTML = source.innerHTML;
        });
        productInfo.querySelectorAll('[data-gx-shipping]').forEach(target => {
          target.hidden = !data.variant.requires_shipping;
        });
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}
